import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonCoQuanDaGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loaiCapCoQuanDaGiaiQuyetID: null,
      data: [],
      allData: []
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }

  loadData(loaiCapCoQuanDaGiaiQuyetID) {
    let params = {
      capCoQuanQuanLy: loaiCapCoQuanDaGiaiQuyetID
    }
    DuLieuHeThong.actions.getCoQuanDaGiaiQuyet.request(params).then(res => {
      if (typeof res.data._embedded != "undefined") {
        // TODO: Use Redux

        this.setState({
          data: res.data._embedded.coQuanQuanLies
        })
      }
    }).catch(err => {})
  }

  componentDidMount() {
    if (this.props.loaiCapCoQuanDaGiaiQuyetID) {
      this.loadData(this.props.loaiCapCoQuanDaGiaiQuyetID);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loaiCapCoQuanDaGiaiQuyetID && this.props.loaiCapCoQuanDaGiaiQuyetID != nextProps.loaiCapCoQuanDaGiaiQuyetID) {
      if (typeof this.state.allData[nextProps.loaiCapCoQuanDaGiaiQuyetID] != "undefined") {
        this.setState({
          data: this.props.data[nextProps.loaiCapCoQuanDaGiaiQuyetID]
        });
      } else {
        this.loadData(nextProps.loaiCapCoQuanDaGiaiQuyetID);
      }
    } else if (nextProps.loaiCapCoQuanDaGiaiQuyetID == ''){
      this.setState({
        data: []
      });
    }
  }

  render() {
    return (
      <DropDown className={`col-input ${this.state.data.length == 0 ? ' hidden' : ''}`} selectedValue={this.props.selectedValue} label="Cơ quan đã giải quyết" require={this.props.require} options={ this.state.data } keyName='coQuanQuanLyId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    )
  }
}

DropDownChonCoQuanDaGiaiQuyet.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  selectedValue: ''
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.coQuanDaGiaiQuyet
  }
}

export default connect(bindStateToProps)(DropDownChonCoQuanDaGiaiQuyet);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-choncoquandagiaiquyet.jsx